module.exports = __webpack_public_path__ + "assets/img/25_434_big.c65fe149.jpg";